import {
  BasePaymentClient,
  Payments,
  PayWithSavedMethodInput,
  SavePaymentCardArgs,
  SavePaymentCardResponse,
  SbpPaymentArgs,
  TinkoffGetQr,
  TinkoffPayment,
  TOrder,
} from "@core/types";
import { CreateYooKassaPaymentInput } from "@core/types";
import { SupaPayment } from "../types/supabaseFragments";
import { convertTinkoffGetQr, convertTinkoffPayment } from "./converters";

class PaymentClient extends BasePaymentClient {
  async getYooKassaPayment(paymentId: string) {
    throw new Error("getYooKassaPayment not implemented");
  }

  async createYooKassaPayment(input: CreateYooKassaPaymentInput): Promise<any> {
    throw new Error("createYooKassaPayment not implemented");
  }

  async payWithSavedMethod(input: PayWithSavedMethodInput): Promise<any> {
    throw new Error("payWithSavedMethod not implemented");
  }

  async createPaymentTinkoffQr(orderId: TOrder["id"]): Promise<TinkoffGetQr | null> {
    const response = await this.instance.post(`/payments-qr/${orderId}`);

    return response?.data ? convertTinkoffGetQr(response.data) : null;
  }

  async getTinkoffPayment(orderId: TOrder["id"]): Promise<TinkoffPayment | null> {
    const response = await this.instance.get<SupaPayment>(`/payments-qr/${orderId}`);

    return response.data ? convertTinkoffPayment(response.data) : null;
  }
  async savePaymentCard(args: SavePaymentCardArgs): Promise<SavePaymentCardResponse> {
    throw new Error("savePaymentCard not implemented");
  }

  async createSBPPayment(args: SbpPaymentArgs): Promise<Payments | null> {
    throw new Error("createSBPPayment not implemented");
  }
}

export default PaymentClient;
